import PropTypes from 'prop-types';

const Box = ({ fill, width, height }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width}
    height={height}
  >
    <polygon style={{ fill }} points="16.35 9.31 19.59 7.43 12.31 3.21 9.06 5.09 16.35 9.31" />
    <polygon style={{ fill }} points="8.07 5.67 5.04 7.43 12.31 11.64 15.35 9.89 8.07 5.67" />
    <polygon style={{ fill }} points="11.81 12.51 4.54 8.3 4.54 16.72 11.81 20.96 11.81 12.51" />
    <path
      style={{ fill }}
      d="M12.81,12.51V21l7.28-4.24V8.3Zm5.28.15-2.41,1.39a.47.47,0,0,1-.25.07.5.5,0,0,1-.25-.93l2.41-1.4a.5.5,0,1,1,.5.87Z"
    />
  </svg>
);

export default Box;

Box.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

Box.defaultProps = {
  fill: '#fff',
  width: 'auto',
  height: 'auto'
};
